<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Wrapper -->
<!-- Cuando la vista no lleva header, el contenido queda pegado al borde superior de la
  pantalla, así que es el wrapper el que reserva la franja de la status bar. -->
<div class="flex flex-col flex-auto w-full" [class.pt-safe-top]="backService.noHeader">
  <!-- Ancla del header scroll-aware: mientras se ve, el header va opaco; al salir del
    viewport pasa a translúcido con blur (ver `ngAfterViewInit`). -->
  <div #anchorElement></div>
  @if (!backService.noHeader) {
    <!-- El padding superior suma la franja de status bar al `py-2.5` propio: dentro de la
      app móvil este header llega hasta el borde de la pantalla (sea sticky o relative) y
      sin esto el logo y el botón de cerrar quedan encima de la hora. Fuera de la app
      `--bp-safe-top` vale 0 y el padding es el de siempre. -->
    <!-- En mobile el header queda pegado al borde superior mientras se scrollea, igual que
      el app bar del layout `bp` (que es `fixed top-0 md:relative`): dentro de la app la
      barra que se va con el contenido no se siente nativa. Desde `md` vuelve a `relative`
      y acompaña al scroll, que es el comportamiento del portal en escritorio.
      Se usa `sticky` en vez de `fixed` porque no saca al header del flujo, así el
      contenido no necesita margen superior compensatorio y no hay salto al entrar. -->
    <div
      class="grid grid-cols-[auto,1fr,auto] items-center flex-0 py-2.5 pt-[calc(0.625rem*var(--zoom)+var(--bp-safe-top))] px-6 dark:bg-gray-700 sticky top-0 z-49 md:relative"
      [ngClass]="{
        'border-b': !backService.noBorderHeader && !shadow,
        'bg-white transition-all duration-200': !shadow,
        'shadow bg-white-blur backdrop-blur-md transition-all duration-300': shadow,
      }"
    >
      <!-- Logo/back button -->
      <div class="grid content-center logo" [style.viewTransitionName]="'betterplan-logo-mobile'">
        @if (isFirstStep !== undefined && isFirstStep) {
          <a [routerLink]="'/dashboard'" [attr.data-cy]="'bps-img-btn'" @fadeIn>
            @if (appConfig.scheme === 'dark') {
              <img
                src="assets/img/auxi/logo-betterplan-white.svg"
                class="hidden w-auto h-7 sm:block"
                alt="Betterplan Advisors"
                title="Betterplan Advisors"
              />
            }
            @if (appConfig.scheme === 'dark') {
              <img
                src="assets/img/auxi/betterplan-b-light.svg"
                class="block w-auto h-7 sm:hidden"
                alt="Betterplan Advisors"
                title="Betterplan Advisors"
              />
            }
            @if (appConfig.scheme === 'light') {
              <img
                src="assets/img/auxi/logo-full.svg"
                class="hidden w-auto h-7 sm:block"
                alt="Betterplan Advisors"
                title="Betterplan Advisors"
              />
            }
            @if (appConfig.scheme === 'light') {
              <img
                src="assets/img/logo-loading.svg"
                class="block w-auto h-7 sm:hidden"
                alt="Betterplan Advisors"
                title="Betterplan Advisors"
              />
            }
          </a>
        }
        @if (isFirstStep !== undefined && !isFirstStep) {
          <button
            class="max-h-7"
            mat-icon-button
            (click)="back()"
            @fadeIn
            [attr.data-cy]="'bps-back-btn'"
          >
            <mat-icon
              class="icon-size-5 text-accent"
              [svgIcon]="'heroicons_solid:arrow-left'"
            ></mat-icon>
          </button>
        }
      </div>

      <!-- Center zone (customizable via BpHeaderService) -->
      <div class="flex items-center justify-center">
        @if (headerConfig?.center) {
          <!-- Template-based content (priority) -->
          <div
            [ngClass]="{
              'md:hidden': headerConfig?.hideFrom === 'md',
              'lg:hidden': headerConfig?.hideFrom === 'lg',
              'xl:hidden': headerConfig?.hideFrom === 'xl',
              'hidden md:block': headerConfig?.showFrom === 'md',
              'hidden lg:block': headerConfig?.showFrom === 'lg',
              'hidden xl:block': headerConfig?.showFrom === 'xl'
            }"
          >
            <ng-container [ngTemplateOutlet]="headerConfig!.center"></ng-container>
          </div>
        } @else if (scrollHeaderContent) {
          <!-- Contenido dinámico por scroll (solo mobile, publicado por bpScrollHeader) -->
          <div @fadeIn class="flex items-center justify-center md:hidden">
            <ng-container [ngTemplateOutlet]="scrollHeaderContent"></ng-container>
          </div>
        } @else if (centerConfig) {
          <!-- Simple text-based content -->
          <span class="font-medium text-accent" [ngClass]="getCenterConfigClasses()">
            {{ centerConfig.text }}
          </span>
        }
      </div>

      <!-- Close button -->
      <div class="flex items-center justify-end">
        <a (click)="close()" mat-icon-button @fadeIn [attr.data-cy]="'bps-close-btn'">
          <mat-icon
            class="icon-size-5 text-accent"
            [svgIcon]="'heroicons_solid:x-mark'"
          ></mat-icon>
        </a>
      </div>
    </div>
  }
  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
  Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
